import React from 'react';
import { Shield, Users, Trophy, AlertCircle, Award } from 'lucide-react';

const RegolamentoPage = () => {
  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          REGOLAMENTO
        </h1>
        <div className="w-20 h-1 mb-8 sm:mb-10" style={{ backgroundColor: 'var(--tp-red)' }} />

        {/* Nota Iniziale */}
        <div className="mb-8 p-4 sm:p-6 rounded-lg border-l-4 border-yellow-500" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-start gap-3">
            <AlertCircle size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-lg font-bold text-white mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>N.B.</h3>
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                Le iscrizioni sono aperte a tutti, non accettiamo minori di 13 anni, per i minori sotto i 16 anni è necessario presentarsi con un genitore\tutore o con una dichiarazione scritta, controfirmata e accompagnata dalla fotocopia di un documento di un genitore o tutore del minore che dichiara di essere a conoscenza della presenza dello stesso alla manifestazione e di essere conscio degli impegni che si assume partecipando al torneo.
              </p>
            </div>
          </div>
        </div>

        {/* Eliminatorie */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Users size={24} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              ELIMINATORIE
            </h2>
          </div>
          <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>
              Ogni iscritto avrà a disposizione <strong className="text-white">30 secondi</strong> nei quali viene richiesto semplicemente di improvvisare oppure scegliere di fare una strofa di 16 barre.
            </p>
            <p>
              Nella eliminatoria non verranno in nessun modo accolte rime che offendano i diritti umani o sessisti o che offendano direttamente qualcuno.
            </p>
            <p>
              In questa fase verrà valutato: <strong className="text-white">il linguaggio, la grammatica</strong>, il contenuto può essere anche frivolo ma in questa fase non ci interessano rime da battaglia.
            </p>
          </div>
        </section>

        {/* Primo Turno */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Shield size={24} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              Primo Turno STILE LIBERO (16 MC)
            </h2>
          </div>
          <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>Nel primo turno gli MC si sfideranno 1 Vs 1 con la seguente modalità:</p>
            <p className="text-white font-semibold">TRE SET DA 1 MINUTO</p>
            <p>Ad ogni set si procederà alla votazione.</p>
            <p>Se un MC riceverà due vittorie consecutive non si procederà al set successivo, a rigor di logica il terzo.</p>
            <div className="p-3 rounded border-l-4 border-red-600 bg-red-900/20">
              <p className="text-red-400 font-bold">-ELIMINAZIONE IMMEDIATA ALL'USO DI BESTEMMIE-</p>
            </div>
            <p>
              Vota il pubblico coadiuvato dal HOST della serata e una eventuale giuria, che valuterà di convalidare il voto o esprimersi per uno spareggio.
            </p>
            <p>
              Qualora si necessiti spareggio, si svolgerà in 1 Minuto 4\4 a testa e sarà rigorosamente ad argomento.
            </p>
          </div>
        </section>

        {/* TOP OF THE HEAD */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Trophy size={24} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              TOP OF THE HEAD (8 MC)
            </h2>
          </div>
          <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>
              <strong className="text-white">4 entrate a testa 4\4</strong> con argomento che cambia ad ogni entrata.
            </p>
            <p>
              Vota il pubblico coadiuvato dal HOST della serata e una eventuale giuria, che valuterà di convalidare il voto o esprimersi per uno spareggio.
            </p>
            <p>
              Qualora si necessiti spareggio, si svolgerà in 1 Minuto 4\4 a testa e sarà rigorosamente ad argomento.
            </p>
            <p>
              Se si sceglie un ulteriore spareggio si sfideranno con una strofa acappella di 16 barre.
            </p>
          </div>
        </section>

        {/* DA CYPHA */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Users size={24} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              DA CYPHA - Semifinale (4 MC)
            </h2>
          </div>
          <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>
              Nel terzo turno c'è il <strong className="text-white">Cypha, il cerchio</strong>, viene chiesto ai 4 MC di inventarsi un argomento a giro, sarà di 4\4 a testa per un totale di 4 ritornelli che alterneranno alle quartine improvvisate dei 4 MC, il primo MC inventerà un ritornello, quando rincomincia il giro sarà il secondo, così via fino al quarto.
            </p>
            <p>
              Il beat cambierà a tempo per ogni giro da capo che durerà 16 battute + 4 di chiusura.
            </p>
            <p>
              L'MC che perde il tempo esce dal cerchio e viene eliminato, a meno che il suo errore non venga causato da problemi tecnici dell'impianto o della base.
            </p>
            <p>
              Per gli MC rimasti vota il pubblico coadiuvato dal HOST della serata, che valuterà di convalidare il voto o esprimersi per uno spareggio.
            </p>
          </div>
        </section>

        {/* Finale */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Trophy size={24} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              Finale (2MC) GIRO DELLA MORTE
            </h2>
          </div>
          <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
            <p>
              <strong className="text-white">Giro della morte</strong>, i due mc si sfideranno in freestyle fino a che uno dei due si arrende oppure cominciano a ripetersi per stanchezza.
            </p>
            <p>
              In caso di spareggio i due MC si sfideranno con una strofa acappella a testa e il pubblico voterà quella che preferisce.
            </p>
          </div>
        </section>

        {/* Opzione Spareggi */}
        <section className="mb-8 p-4 sm:p-6 rounded-lg border-l-4 border-orange-500" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-start gap-3">
            <AlertCircle size={24} className="text-orange-500 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>
                ATTENZIONE - OPZIONE SPAREGGI
              </h2>
              <div className="space-y-2 text-gray-300 text-sm sm:text-base leading-relaxed">
                <p>
                  C'è la possibilità di finire in pareggio il giro della morte, da questa edizione il pareggio sarà concesso solo ed esclusivamente se a richiederlo sarà il pubblico in accordo con la giuria.
                </p>
                <p>
                  Non sarà quindi più possibile chiedere il pareggio da parte dei partecipanti\finalisti (per evitare come già successo accordi pre gara tra i due semifinalisti).
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Premio */}
        <section className="p-4 sm:p-6 rounded-lg border-2 border-red-600" style={{ backgroundColor: 'var(--tp-dark)' }}>
          <div className="flex items-center gap-3 mb-4">
            <Award size={28} className="text-red-500" />
            <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>
              PREMIO DELLA SEMIFINALE
            </h2>
          </div>
          <div className="space-y-4">
            <div className="p-4 rounded-lg bg-red-900/20">
              <p className="text-red-400 font-bold text-base sm:text-lg mb-2">
                "RIMBORSO VIAGGIO" PER LA DATA FINALE
              </p>
              <p className="text-white text-sm sm:text-base">
                Endorsement di abbigliamento offerti dal Main Sponsor.
              </p>
            </div>
            <div className="space-y-3 text-gray-300 text-sm sm:text-base leading-relaxed">
              <p>
                Per evitare incomprensioni tra le organizzazioni e lo STAFF principale di Tecniche Perfette verrà acquistato il biglietto del viaggio a/r del vincitore nelle 72 ore successive alla vincita, che comporta l'impegno di essere presenti alla finalissima.
              </p>
              <p>
                La mancata presenza comporterà il rimborso del biglietto da parte del vincitore, con valuta del giorno stesso della comunicata assenza in finale.
              </p>
              <p className="text-white font-semibold">
                Non è previsto vitto e alloggio.
              </p>
              <p>
                In alcune Date gli organizzatori possono mettere in palio del denaro che sarà a discrezione totale degli stessi.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RegolamentoPage;
